import { useMemo } from "react";
import { useParams } from "react-router-dom";

// eslint-disable-next-line import/no-useless-path-segments -- disambiguate the folder entry from the legacy sibling file
import HistoryPageNavbar from "./HistoryPageNavbar/index";

import { SidebarTrigger } from "@/components/ui/sidebar";
import { useRequest, useRequestBulk } from "@/queries";

const PageNavbar = ({ requestId }: { requestId: string }) => {
  const request = useRequest(requestId);
  const requestBulk = useRequestBulk(requestId);
  const requestInfo = useMemo(() => {
    if (!request.data && !requestBulk.data) {
      return undefined;
    }

    return { ...request.data, ...requestBulk.data };
  }, [request.data, requestBulk.data]);

  return (
    <div className="flex w-full px-8 pt-8">
      <HistoryPageNavbar requestId={requestId} requestInfo={requestInfo} />
    </div>
  );
};

const RequestContentNavbar = ({ onHistoryPage }: { onHistoryPage: boolean }) => {
  const { requestId } = useParams();

  return (
    <div className="top-0 flex min-h-16 flex-shrink-0 border-b border-gray-200 bg-white md:border-0">
      <SidebarTrigger className="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500 md:hidden" />
      {onHistoryPage && requestId ? <PageNavbar requestId={requestId} /> : null}
    </div>
  );
};

export default RequestContentNavbar;
